/**
 * Modelo de operación de una fichada.
 *
 * @export
 * @class Operation
 */
export class Operation{

    /**
     * Nombre de la operación.
     *
     * @private
     * @type {string}
     * @memberof Operation
     */
    private _name: string = '';

    /**
     * Código de la operación (id_reg_ofsprod_operacion).
     *
     * @private
     * @type {string}
     * @memberof Operation
     */
    private _code: string = '';


    /**
     * Código del producto asociado a la operación (id_reg_ofsproductos).
     *
     * @private
     * @type {string}
     * @memberof Operation
     */
    private _product: string = '';


    /**
     * Crea una instancia de Operation.
     * 
     * @param {*} [params={}] Parámetros para crear la operación.
     * @memberof Operation
     */
    constructor(params:any = {}){
        if(typeof params.name != 'undefined') this._code = params.code;
        if(typeof params.name != 'undefined') this._name = params.name;
        if(typeof params.product != 'undefined') this._product = params.product;

        if(typeof params.id_reg_ofsprod_operacion != 'undefined') this._code = params.id_reg_ofsprod_operacion;
        if(typeof params.operacionMaquina != 'undefined') this._name = params.operacionMaquina;
        if(typeof params.id_reg_ofsproductos != 'undefined') this._product = params.id_reg_ofsproductos;
    }



    /**
     * Nombre getter
     *
     * @type {string}
     * @memberof Operation
     */
    get name(): string{
        return this._name;
    }

    /**
     * Nombre setter
     *
     * @memberof Operation
     */
    set name(name: string){
        this._name = name;
    }


    /**
     * Código getter
     *
     * @type {string}
     * @memberof Operation
     */
    get code(): string{
        return this._code;
    }

    /**
     * Código setter
     *
     * @memberof Operation
     */
    set code(code: string){
        this._code = code;
    }

    /**
     * Producto setter
     *
     * @memberof Operation
     */
    set product(product: string){
        this._product = product;
    }

    /**
     * Producto getter
     *
     * @type {string}
     * @memberof Operation
     */
    get product(): string{
        return this._product;
    }

}


// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/operation.model.ts